import styled from 'styled-components'

export { StickyPreviewContainer as Container } from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp40} ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius3};
  word-break: break-word;
`
